// Today's date in India time (YYYY-MM-DD) — reports open on "today" by default.
export function todayIST() {
  return new Date(Date.now() + 5.5 * 3600 * 1000).toISOString().slice(0, 10);
}
